import { createFileRoute } from '@tanstack/react-router';
import { ServiceUsageByServicePage } from '@/pages/admin/service-usage/by-service';
import { serviceUsageByServiceSearchSchema } from '@/routes/-shared/serviceUsageSearchSchema';

/**
 * Vista secondaria «Per tipo di servizio»: l'aggregato del periodo, fuori
 * dal layout della lista per tenant (rotta statica, vince su `$tenantId`).
 */
export const Route = createFileRoute('/admin/_layout/service-usage/by-service')(
  {
    component: ServiceUsageByServicePage,
    validateSearch: serviceUsageByServiceSearchSchema,
  }
);
